module.exports = __webpack_public_path__ + "img/UnionPay.5a886488.png";